// ServiceCheck.js
import React from 'react';
import AlertTypePage from './AlertTypePage';

const ServiceCheck = () => {
    return <AlertTypePage alertType="Service Check" title="Service Check" />;
};

export default ServiceCheck;